import React from "react";
export const withForwardedRef = (Component) => {
    const WithForwardedRef = (props, ref) => (React.createElement(Component, Object.assign({}, props, { forwardedRef: ref })));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return React.forwardRef(WithForwardedRef);
};
export default withForwardedRef;
//# sourceMappingURL=withForwardedRef.js.map